import EmblaCarousel from 'embla-carousel';

function setupEmblaSlider(root) {
    const viewport = root.querySelector('.embla__viewport');
    if (!viewport) {
        return;
    }

    const prevBtn = root.querySelector('.embla__button--prev');
    const nextBtn = root.querySelector('.embla__button--next');
    const dotsRoot = root.querySelector('.embla__dots');

    const slideCount = root.querySelectorAll('.embla__slide').length;
    if (!slideCount) {
        return;
    }

    if (slideCount <= 1) {
        if (dotsRoot) {
            dotsRoot.hidden = true;
        }
        if (prevBtn) {
            prevBtn.hidden = true;
        }
        if (nextBtn) {
            nextBtn.hidden = true;
        }
    }
    const loopEnabled = slideCount > 1;
    const emblaApi = EmblaCarousel(viewport, {
        loop: loopEnabled,
        align: 'start',
        containScroll: loopEnabled ? false : 'trimSnaps',
    });

    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    if (prevBtn) {
        prevBtn.addEventListener('click', scrollPrev);
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', scrollNext);
    }

    const renderDots = () => {
        if (!dotsRoot) {
            return;
        }
        dotsRoot.innerHTML = '';
        emblaApi.scrollSnapList().forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'embla__dot';
            dot.setAttribute('aria-label', `Slide ${index + 1}`);
            dot.addEventListener('click', () => emblaApi.scrollTo(index));
            dotsRoot.appendChild(dot);
        });
        syncDots();
    };

    const syncDots = () => {
        if (!dotsRoot) {
            return;
        }
        const selected = emblaApi.selectedScrollSnap();
        Array.prototype.forEach.call(dotsRoot.children, (dot, i) => {
            dot.classList.toggle('is-selected', i === selected);
        });
    };

    const toggleNavDisabled = () => {
        if (loopEnabled) {
            if (prevBtn) {
                prevBtn.removeAttribute('disabled');
            }
            if (nextBtn) {
                nextBtn.removeAttribute('disabled');
            }
            return;
        }
        if (prevBtn) {
            prevBtn.toggleAttribute('disabled', !emblaApi.canScrollPrev());
        }
        if (nextBtn) {
            nextBtn.toggleAttribute('disabled', !emblaApi.canScrollNext());
        }
    };

    const onSelect = () => {
        syncDots();
        toggleNavDisabled();
    };

    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', () => {
        renderDots();
        onSelect();
    });

    renderDots();
    onSelect();
}

document.querySelectorAll('.embla.block-slider').forEach(setupEmblaSlider);
